/**
 * Get currency sign from currency code
 *
 * For example USD = $, EUR = €
 *
 * If this is an invalid currency, will return undefined
 */

import { useI18n } from 'vue-i18n'

export function getCurrencySign(currencyCode: string) {
  try {
    const formatCurrency = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode,
      currencyDisplay: 'narrowSymbol',
    })

    const currencySymbol = formatCurrency
      .formatToParts()
      .find((part) => part.type === 'currency')?.value

    return currencySymbol
  } catch (error) {
    console.error(error)
  }
}

/**
 * Get package unit based on bo variable
 *
 * For example PerPerson = p/item, PerEvent = ?
 *
 * If this is an invalid currency, will return undefined
 */
// TODO: see if is necessary for package event
export function getPackageUnit(packageCode: string) {
  const { t } = useI18n()

  try {
    switch (packageCode) {
      case 'PerPerson':
        return t('p/item')
      case 'PerEvent':
        return t('p/event')
      default:
        return t('p/item')
    }
  } catch (error) {
    console.error(error)
  }
}

/**
 * Format price, and uses global configuration to display decimals
 */
export function formatPrice(price?: number, currencyCode?: string): string | undefined {
  if (!price) return undefined
  if (!currencyCode) return String(price)

  const currencyFormatter = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

  return currencyFormatter.format(price)
}
